import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress, CircularProgressLabel,
    InputGroup, InputRightElement, InputRightAddon, Icon, IconButton,
    Stack, HStack, Image, Wrap, WrapItem, Center,
    Grid, GridItem, VStack, Spacer, Divider, Select,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, Link, 
    useDisclosure
} from '@chakra-ui/react';
import ReactPaginate from 'react-paginate';
import { confirmAlert } from 'react-confirm-alert';
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css'
import { MdAddCircleOutline,  MdEdit, MdDeleteForever, MdSave, MdFileOpen, MdCheck, MdDownload } from 'react-icons/md';
import { BsArrowLeftCircle, BsArrowRightCircle } from 'react-icons/bs';
import { FaFileExport } from 'react-icons/fa';

import { FormattedDate, FormattedTime, FormattedNumber } from 'react-intl';
import { withNamespaces } from 'react-i18next';

import { SUCCESS_STATUS, FAILED_STATUS } from '../../../constants';
import "../../../styles/index.scss";

import { 
    apiLoadListServicePrice, apiLoadAServicePrice, apiCreateNewServicePrice, apiUpdateAServicePrice, apiDeleteAServicePrice, 
    apiExportServicePriceListToCSV, apiExportServicePriceListToExcel
} from '../../../redux/apis/ServicePriceApis';
import { clearServicePriceActionStatus, clearAServicePriceDetail, clearServicePriceListRemoteCSV, clearServicePriceListRemoteExcel } from '../../../redux/actions';
import { 
    getServicePriceList, getAServicePrice, getServicePriceActionStatus, getServicePriceActionMsg, getServicePriceError, getServicePriceTotalCount, getServicePriceOffset,
    getServicePriceListRemoteCSV, getServicePriceListRemoteExcel 
} from '../../../redux/selectors';

import NoDataPage from '../../../components/NoData';
import AddEditServicePriceModal from '../Modals/AddEditServicePriceModal';
import ImportExcelServicePriceModal from '../Modals/ImportExcelServicePriceModal';
import { displayConfirmChoiceAlert } from '../../utils';

function ServicePrices({ 
    servicePriceList, servicePriceDetail, actionStatus, actionMsg, error, totalCount, offset, remoteCSV, remoteExcel, t,
    clearServicePriceActionStatus, clearAServicePriceDetail, clearServicePriceListRemoteCSV, clearServicePriceListRemoteExcel,
    apiLoadListServicePrice, apiLoadAServicePrice, apiCreateNewServicePrice, apiUpdateAServicePrice, apiDeleteAServicePrice, 
    apiExportServicePriceListToCSV, apiExportServicePriceListToExcel,
}) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const initialRef = useRef(null);
    
    const [ searchText, setSearchText ] = useState("");
    const [ isSearching, setIsSearching ] = useState(false);
    const [ isAction, setIsAction ] = useState(false);
    const [ exportFileType, setExportFileType ] = useState("EXCEL");

    const mounted = useRef();
    const servicePriceImportExcelModal = useDisclosure();
    const limit = 10;
    const pageCount =  Math.ceil(totalCount / limit);

    useEffect(() => {
        if(!mounted.current) {
            apiLoadListServicePrice({ 
                company_id: cookies?.loginCookie?.data?.company_id 
            });
            setIsAction(cookies.loginCookie?.data?.roles === "admin" || cookies.loginCookie?.data?.roles === "super_admin");
            mounted.current = true;
        } else {
            if(actionStatus === SUCCESS_STATUS) {
                if(isOpen) {
                    onClose();
                }
                toast.success(actionMsg, {
                    position: "bottom-right"
                });
                clearServicePriceActionStatus();
            } 
            else if(actionStatus === FAILED_STATUS) {         
                toast.error(error, {
                    position: "bottom-right"
                });
                clearServicePriceActionStatus();
            }
        }
    });

    useEffect(() => {
        setIsSearching(false);
    }, [servicePriceList]);

    useEffect(() => {
        if(remoteCSV){
            const blobCSV = new Blob([remoteCSV], {type: 'text/csv;charset=UTF-8'});
            //Build a URL from the file
            const fileURL = window.URL.createObjectURL(blobCSV);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute("download", `${cookies?.loginCookie?.data?.companyDetail?.name + "_DanhMucDichVu"}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            clearServicePriceListRemoteCSV();
        }
    }, [remoteCSV]);

    useEffect(() => {
        if (remoteExcel){
            const blobEXCEL = new Blob([remoteExcel], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'});
            //Build a URL from the file
            const fileURL = window.URL.createObjectURL(blobEXCEL);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute("download", `${cookies?.loginCookie?.data?.companyDetail?.name + "_DanhMucDichVu"}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            clearServicePriceListRemoteExcel();
        }
    }, [remoteExcel]);
    
    const handleAddNewServicePrice = () => {
        clearAServicePriceDetail();
        onOpen();
    }

    const handleUpdateAServicePrice = (servicePrice_id) => {
        apiLoadAServicePrice({ id: servicePrice_id });
    }

    const handleDeleteAServicePrice = (servicePrice_id) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        <h1>
                            Xác nhận <br />Bạn có muốn xoá dịch vụ này không?
                        </h1>
                        <div>
                            <button onClick={onClose}>Huỷ</button>
                            <button
                                onClick={() => {
                                    apiDeleteAServicePrice({ 
                                        id: servicePrice_id, 
                                        payload: { 
                                            company_id: cookies?.loginCookie?.data?.company_id,
                                            user_id: cookies?.loginCookie?.data?.id,  
                                            is_active: false 
                                        } 
                                    });
                                    onClose();
                                }}
                                className='yes'
                            >
                                Đồng Ý
                            </button>
                        </div>
                    </div>
                )
            },
            closeOnClickOutside: false
        })
    }

    const handleExportServicePriceList = () => {
        displayConfirmChoiceAlert(`Bạn có muốn xuất dữ liệu ra file ${exportFileType}`, () => {
            if(exportFileType === "CSV") {
                apiExportServicePriceListToCSV({ 
                    company_id: cookies?.loginCookie?.data?.company_id,
                    user_id: cookies?.loginCookie?.data?.id,    
                });
            } else if(exportFileType === "EXCEL") {
                apiExportServicePriceListToExcel({ 
                    company_id: cookies?.loginCookie?.data?.company_id,
                    user_id: cookies?.loginCookie?.data?.id,    
                });
            } 
        })
    }

    const handleImportDataFinished = () => {
        apiLoadListServicePrice({ company_id: cookies?.loginCookie?.data?.company_id });
    }
    
    return (
        <React.Fragment>
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} borderBottomWidth="2px" px={4} py={2} gap={2} justify="space-between">
                <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} gap={2}>
                    <Button colorScheme='orange' isDisabled={!isAction} onClick={handleAddNewServicePrice}>
                        <Icon boxSize={6} as={MdAddCircleOutline} marginRight="8px"/>   
                        <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Add")}</Text>
                    </Button>

                    <Button colorScheme='teal' isDisabled={!isAction} onClick={() => servicePriceImportExcelModal.onOpen()}>
                        <Icon boxSize={6} as={MdFileOpen} marginRight="8px"/>   
                        <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Import_Data_From_File")}</Text>
                    </Button>

                    <InputGroup maxW="250px">
                        <Button paddingRight={1} borderTopRightRadius={0} borderBottomRightRadius={0} isDisabled={!isAction}
                                onClick={() => handleExportServicePriceList()}
                        >
                            <Icon boxSize={6} as={FaFileExport} marginRight="8px"/>  
                            <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Export_File")}</Text>
                        </Button>
                        <InputRightAddon p={0}>
                            <Select value={exportFileType} borderTopLeftRadius={0} borderBottomLeftRadius={0} isDisabled={!isAction}
                                onChange={(evt) => setExportFileType(evt.currentTarget.value)}
                            >
                                <option value="EXCEL">EXCEL</option>
                                <option value="CSV">CSV</option>
                            </Select>
                        </InputRightAddon>
                    </InputGroup>
                </Flex>

                <InputGroup width={{base: "100%", md: "40%", lg: "40%"}}>
                    <Input placeholder={t("Type_Search_Text")} onChange={(evt) => setSearchText(evt.currentTarget.value)} onKeyUp={(evt) => {
                        if(evt.key === "Enter") {
                            setIsSearching(true);                           
                            setTimeout(() => {
                                apiLoadListServicePrice({ searchText, company_id: cookies?.loginCookie?.data?.company_id });
                            }, 500);
                        }
                    }}/>
                    <InputRightAddon p={0}>
                        <Button colorScheme='blue' 
                            isLoading={isSearching}
                            loadingText={t("Searching")}
                            onClick={() => {
                                setIsSearching(true);
                                setTimeout(() => {
                                    apiLoadListServicePrice({ searchText, company_id: cookies?.loginCookie?.data?.company_id });
                                }, 500);
                            }
                        }>
                            {t("Search")}
                        </Button>
                    </InputRightAddon>
                </InputGroup>
            </Flex>

            <PaginatedItems 
                items={servicePriceList} itemsPerPage={limit} itemOffset={offset} pageCount={pageCount} 
                onOpen={onOpen} isAction={isAction} t={t}
                handleUpdateAServicePrice={handleUpdateAServicePrice} handleDeleteAServicePrice={handleDeleteAServicePrice} 
                apiLoadListServicePrice={apiLoadListServicePrice}
            />

            {
                !(servicePriceList && servicePriceList.length > 0) &&
                <NoDataPage text="Hiện tại không có dữ liệu"/>
            }
            {   
                isOpen &&
                <AddEditServicePriceModal 
                    initialRef={initialRef} isOpen={isOpen} onClose={onClose} company_id={cookies?.loginCookie?.data?.company_id} 
                    servicePriceList={servicePriceList} servicePriceDetail={servicePriceDetail} actionStatus={actionStatus}
                    apiCreateNewServicePrice={apiCreateNewServicePrice} apiUpdateAServicePrice={apiUpdateAServicePrice}
                />
            }
            {
                servicePriceImportExcelModal.isOpen &&
                <ImportExcelServicePriceModal
                    initialRef={initialRef} isOpen={servicePriceImportExcelModal.isOpen} onClose={servicePriceImportExcelModal.onClose} 
                    company_id={cookies?.loginCookie?.data?.company_id} onImportDataFinished={handleImportDataFinished}
                />
            }
            <ToastContainer />
        </React.Fragment>
    )
}

function PaginatedItems({ 
    items, itemsPerPage, itemOffset, pageCount, t,
    onOpen, isAction, apiLoadListServicePrice, handleUpdateAServicePrice, handleDeleteAServicePrice 
}) {
    const [ cookies ] = useCookies(["loginCookie"]);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage);
        apiLoadListServicePrice({ company_id: cookies?.loginCookie?.data?.company_id, limit: itemsPerPage, offset: newOffset });
    } 

    return (
        <>
            <TableContainer width="100%" px="20px" py="5px">
                <Table variant="simple" size="sm">
                    <Thead>
                        <Tr bg="#EAF0F0">
                            <Th>{t("Index")}</Th>
                            <Th>{t("Name")}</Th>
                            <Th>{t("Unit_Price")}</Th>
                            <Th>{t("Default_Fee")}</Th>
                            <Th>{t("Created_At")}</Th>
                            <Th>{t("Edited_At")}</Th>
                            <Th isNumeric></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            items && items.map((item, idx) => {
                                return (
                                    <Tr key={item.id}>
                                        <Td>
                                            <Text fontWeight="600">{itemOffset + idx + 1}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.name}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">
                                                { item.price && <FormattedNumber value={item.price}></FormattedNumber> }
                                            </Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.is_initial_fee ? <IconButton variant="outline" colorScheme='green' icon={<MdCheck />} size="sm"/> : ""}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">
                                                <FormattedDate value={item.created_at} /> <FormattedTime value={item.created_at} />
                                            </Text>
                                        </Td>
                                        <Td>
                                            {
                                                item.updated_at &&
                                                <Text fontWeight="600">
                                                    <FormattedDate value={item.updated_at} /> <FormattedTime value={item.updated_at} />
                                                </Text>
                                            }
                                        </Td>
                                        <Td isNumeric>
                                            <Flex direction="row" justifyContent="flex-end" alignContent="center" gap={1}>
                                                <IconButton
                                                    colorScheme='blackAlpha'
                                                    title='Sửa'
                                                    icon={<MdEdit />}
                                                    isDisabled={!isAction}
                                                    onClick={() => {
                                                            onOpen();
                                                            handleUpdateAServicePrice(item.id);
                                                        }
                                                    }
                                                />
                                                <IconButton
                                                    colorScheme='red'
                                                    title='Xoá'
                                                    icon={<MdDeleteForever />}
                                                    isDisabled={!isAction}
                                                    onClick={() => handleDeleteAServicePrice(item.id)}
                                                />
                                            </Flex>
                                        </Td>
                                    </Tr>
                                )
                            })
                        }
                    </Tbody>
                </Table>
            </TableContainer>

            {/* <Flex w="100%" justify="center" my="10px" position={{base: "relative", md: "fixed", lg: "fixed"}} bottom="0px"> */}
                <ReactPaginate 
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowLeftCircle} />
                        </Center>
                    }
                    nextLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowRightCircle} />
                        </Center>
                    }
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageClassName='page-item'
                    activeClassName='active'
                    previousClassName='previous-item'
                    nextClassName='next-item'
                />
            {/* </Flex> */}
        </>
    )
}

const mapStateToProps = (state) => {
    const servicePriceList           =   getServicePriceList(state);
    const servicePriceDetail         =   getAServicePrice(state);
    const actionStatus               =   getServicePriceActionStatus(state);
    const actionMsg                  =   getServicePriceActionMsg(state);
    const error                      =   getServicePriceError(state);
    const totalCount                 =   getServicePriceTotalCount(state);
    const offset                     =   getServicePriceOffset(state);
    const remoteCSV                  =   getServicePriceListRemoteCSV(state);
    const remoteExcel                =   getServicePriceListRemoteExcel(state);

    return { servicePriceList, servicePriceDetail, actionStatus, actionMsg, error, totalCount, offset, remoteCSV, remoteExcel };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadListServicePrice:        payload => dispatch(apiLoadListServicePrice(payload)),
    apiLoadAServicePrice:           payload => dispatch(apiLoadAServicePrice(payload)),
    apiCreateNewServicePrice:       payload => dispatch(apiCreateNewServicePrice(payload)),
    apiUpdateAServicePrice:         payload => dispatch(apiUpdateAServicePrice(payload)),
    apiDeleteAServicePrice:         payload => dispatch(apiDeleteAServicePrice(payload)),
    apiExportServicePriceListToCSV: payload => dispatch(apiExportServicePriceListToCSV(payload)),
    apiExportServicePriceListToExcel: payload => dispatch(apiExportServicePriceListToExcel(payload)),

    clearServicePriceActionStatus:  payload => dispatch(clearServicePriceActionStatus(payload)),
    clearAServicePriceDetail:       payload => dispatch(clearAServicePriceDetail(payload)),
    clearServicePriceListRemoteCSV: payload => dispatch(clearServicePriceListRemoteCSV(payload)),
    clearServicePriceListRemoteExcel: payload => dispatch(clearServicePriceListRemoteExcel(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(ServicePrices));